import React, { useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { useSelector } from 'react-redux'
import { formatDate } from '../utils/formatDate'
import { handleOutsideClick } from '../utils/clickOutside'
import CloseIcon from '../utils/closeIcon'
import useBodyOverflow from '../hooks/useBodyOverflow'
import Accordion from './Accordion'

const Modal = ({ isOpen = false, closeModal, modalData }) => {
  const theme = useSelector((state) =>
    state.mapStyle.darkMode ? 'dark' : 'light'
  )

  const [openIndices, setOpenIndices] = useState([])

  useBodyOverflow(isOpen)
  return (
    <Transition appear show={isOpen} as={React.Fragment}>
      <Dialog
        onClose={closeModal}
        className='fixed inset-0 flex items-center justify-center z-50'
        onClick={(event) => handleOutsideClick(event, closeModal)}
      >
        <div className='fixed inset-0 flex items-center justify-center z-50'>
          <div
            className={`fixed inset-0  ${
              theme === 'dark' ? 'bg-[#212121]' : 'bg-white'
            } bg-opacity-25 ${
              isOpen
                ? 'transition-opacity duration-300 opacity-100'
                : 'opacity-0 pointer-events-none'
            }`}
            aria-hidden='true'
          />

          <div
            className={`fixed bottom-24 left-3 w-[380px]  ${
              isOpen
                ? 'transition-transform duration-300 transform translate-y-0'
                : 'translate-y-full'
            }`}
          >
            <div
              className={`shadow-xl rounded-2xl pb-10 ${
                theme === 'dark' ? 'bg-[#212121] text-white' : 'bg-white text-black'
              }`}
            >
              <div className='px-6 py-4'>
                <h1 className='text-2xl font-bold leading-6 mb-4'>
                  Sensor Info
                </h1>
                {modalData && (
                  <>
                    <div className='mb-4'>
                      <p className='text-gray-400 text-sm'>
                        Last stream: {formatDate(modalData[0].properties.date)}
                      </p>
                    </div>
                    <div className='flex justify-start gap-6 pb-4'>
                      <div className='flex flex-col items-center justify-center'>
                        <p className='text-sm text-gray-400 capitalize'>
                          Temperature
                        </p>
                        <div className='text-3xl font-bold text-gray-400'>
                          {modalData[0].properties.temp} ºC
                        </div>
                      </div>
                      <div className='border-l-2 border-gray-300 dark:border-gray-700' />
                      <div className='flex flex-col items-center justify-center'>
                        <p className='text-sm text-gray-400 capitalize'>
                          Humidity
                        </p>
                        <div className='text-3xl font-bold text-gray-400'>
                          {modalData[0].properties.humidity} %
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <Accordion
                openIndices={openIndices}
                setOpenIndices={setOpenIndices}
                modalData={modalData}
              />
              <button
                type='button'
                className={`absolute top-2 right-3 flex items-center justify-center w-8 h-8  rounded-full hover:bg-blue-600 ${
                  theme === 'dark' ? 'bg-zinc-700' : 'bg-zinc-300'
                }`}
                onClick={closeModal}
              >
                <CloseIcon style={{ paddiginLeft: '5px' }} />
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default Modal
